import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TUser } from '../../types/user';

const initialState = {
  user: {} as TUser,
};

export const userSlice = createSlice({
  name: 'userState',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<TUser>) => {
      state.user = action.payload;
    },
  },
});

export const {
  reducer: userReducer,
  actions: { setUser },
} = userSlice;
